import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { supportedLanguages } from '@/i18n'
import { equivalentLocation, languageFromPath } from '@/i18n/routes'
import { LocalizedLink } from './LocalizedLink'

export function LanguageSelector({ variant = 'desktop' }: { variant?: 'desktop' | 'mobile'; isScrolled?: boolean }) {
  const { t } = useTranslation('common')
  const location = useLocation()
  const current = languageFromPath(location.pathname)
  return <nav className={`language-selector language-selector--${variant}`} aria-label={t('aria.language')}>
    {supportedLanguages.map((language) => <LocalizedLink
      key={language} to={equivalentLocation(location, language)} language={language}
      hrefLang={language} lang={language} aria-current={current === language ? 'true' : undefined}
      aria-label={t(`language.${language}`)} state={{ preserveScroll: true }}
    >{t(`language.${variant === 'mobile' ? language : `${language}Short`}`)}</LocalizedLink>)}
  </nav>
}
